namespace $.$$ {

	$mol_style_define( $shm_sort, {

		Options: {
			flex: {
				direction: 'column',
			},
		},

	} )

	$mol_style_define( $shm_sort_item, {
		
		'[selected]': {
			true: {
				color: $mol_theme.current
			},
		},
		
	} )

}
